import React from 'react'
import {Box, TableContainer, Table, TableHead, TableCell, TableBody, TableRow} from '@mui/material'
import {dateFormatter, getStatusDescription, timeFormatter} from 'features/HomePage/TrackShipments/trackshipment.utils'
import 'features/HomePage/TrackShipments/index.scss'
import NoHistory from 'features/HomePage/TrackShipments/components/NoHistory'

interface ShipmentTableProps {
    shipmentHistory: any[]
    routingInfo: Record<string, string>
    shipmentYear: string
    weightUnit: string
    partialCarrier?: Record<string, string>
}

const ShipmentTable: React.FC<ShipmentTableProps> = ({
    shipmentHistory,
    routingInfo,
    shipmentYear,
    weightUnit,
    partialCarrier = {}
}) => {
    const getClassName = (index: number, itemLength: number) => {
        if (index === 0) return 'start-line'
        else if (index === itemLength - 1) return 'end-line'
        else return 'connect-line'
    }

    const getStatus = (status: string) => {
        const currStatus = getStatusDescription(status)
        if (currStatus?.description?.length > 0) return currStatus?.description
        else return currStatus?.status
    }

    return (
        <Box className='table-container'>
            <TableContainer>
                <Table>
                    <TableHead className='table-head'>
                        <TableRow>
                            <TableCell className='table-bold-text date-col'>Date</TableCell>
                            <TableCell className='table-bold-text status-col'>Status</TableCell>
                            <TableCell className='table-bold-text piece-col'>Pieces</TableCell>
                            <TableCell className='table-bold-text weight-col'>Weight</TableCell>
                            <TableCell className='table-bold-text dest-col'>Destination</TableCell>
                            <TableCell className='table-bold-text stn-col'>Status Station</TableCell>
                            <TableCell className='table-bold-text flight-col'>Flight</TableCell>
                        </TableRow>
                    </TableHead>
                    {Object.entries(partialCarrier).length === 0 && (
                        <TableBody className='table-body'>
                            {shipmentHistory?.map((item: any) =>
                                [...item[1]]?.reverse()?.map((innerItem: any, innerIndex: number) => (
                                    <TableRow key={innerIndex}>
                                        {/* DATE COLUMN */}
                                        <TableCell className='table-bold-text table-body-text'>
                                            {innerIndex === 0 &&
                                                (item[0] !== 'undefined'
                                                    ? dateFormatter(item[0], shipmentYear)
                                                    : '- -')}
                                        </TableCell>
                                        {/* STATUS COLUMN */}
                                        <TableCell className='table-body-text'>
                                            <Box className='table-status'>
                                                {item[1].length > 1 && (
                                                    <span className={getClassName(innerIndex, item[1].length)} />
                                                )}
                                                {getStatus(innerItem?.STATUS)}
                                            </Box>
                                            <Box className='table-body-subtext'>
                                                {innerItem?.TIME ? timeFormatter(innerItem?.TIME) : '- -'}
                                            </Box>
                                        </TableCell>
                                        {/* PIECES COLUMN */}
                                        <TableCell className='table-body-text'>
                                            {innerItem?.PIECES?.length > 0 ? innerItem?.PIECES : '- -'}
                                        </TableCell>
                                        {/* WEIGHT COLUMN */}
                                        <TableCell className='table-body-text'>
                                            {innerItem?.WEIGHT?.length > 0
                                                ? `${innerItem?.WEIGHT} ${weightUnit?.toLowerCase()}`
                                                : '- -'}
                                        </TableCell>
                                        {/* DESTINATION COLUMN */}
                                        <TableCell className='table-body-text'>
                                            {/* {innerItem?.STATION ?? '- -'} */}
                                            {routingInfo?.destinationStation?.length > 0
                                                ? routingInfo?.destinationStation
                                                : '- -'}
                                        </TableCell>
                                        {/* STATUS STATION COLUMN */}
                                        <TableCell className='table-body-text'>
                                            {innerItem?.STATUSSTATION?.length > 0 ? innerItem?.STATUSSTATION : '- -'}
                                        </TableCell>
                                        {/* FLIGHT COLUMN */}
                                        <TableCell className='table-body-text'>
                                            {innerItem?.FLTINFO?.length > 0 ? innerItem?.FLTINFO : '- -'}
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    )}
                </Table>
            </TableContainer>
            {Object.entries(partialCarrier).length > 0 && <NoHistory carrierDetails={partialCarrier} />}
        </Box>
    )
}

export default ShipmentTable
